// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

//  export const environment = {
//  	production: false,
//  	serverHttpOrHttps: 'http',
//  	serverAddress: 'localhost',
//  	serverPort: 8080,
//  };

export const environment = {
	production: false,
	serverHttpOrHttps: 'https',
	serverAddress: 'ocashe.newel.net',
	serverPort: 8443,
	serverArtifact: 'ocashe-starter'
};

// export const environment = {
// 	production: false,
// 	serverHttpOrHttps: 'https',
// 	serverAddress: 'preprod-ocashe.newel.net',
// 	serverPort: 8443,
// 	serverArtifact: 'preprod-ocashe-starter'
// };

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
